<template>

    <teleport to="#modal">
        <Loading
            :visible="loading || saving"
        >
        </Loading>
        <ModalApprovaRifiuta
            v-model:visible="approvaModalVisible"
            @approva="approvaAzienda(true)"
            @rifiuta="approvaAzienda(false)"
        >
        </ModalApprovaRifiuta>
    </teleport>
    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto">
            <Alert v-if="show_error_form" :dismissable="true" @close="show_error_form = false"
                   class="bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50">
                Correggi gli errori di inserimento
            </Alert>
            <div class="py-10 flex justify-between items-center">
                <Breadcrumbs :paths="paths"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="primary" v-if="toApprove" @click="approvaModalVisible = !approvaModalVisible"
                                class="w-48 text-center mr-3 py-2 px-4 m-0">
                        Approva/Rifiuta
                    </NextButton>
                    <NextButton variant="outline-secondary" @click="$router.back()"
                                class="w-48 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                    <NextButton variant="primary" v-if="!azienda_model?.non_operativa" @click="save"
                                class="w-48 text-sm sm:block py-2 px-4 ml-3">Salva <i class="spinner"></i>
                    </NextButton>
                </div>
            </div>
            <div class="flex justify-between items-center mb-6">
                <h3 class="text-3xl font-bold ">Anagrafica - {{ azienda_model?.denominazione }}</h3>
                <span class="block text-sm font-bold text-next-stato-2 uppercase border-2 border-next-stato-2 py-2 px-4 w-48 text-center" v-if="azienda_model?.non_operativa">
                    Non operativa
                </span>
            </div>
            <Alert v-if="permission_denied" class="bg-next-orange mb-5 sticky top-0 z-10">Non hai i permessi sufficienti per poter
                modificare l'azienda, o non è stata ancora approvata.
            </Alert>

            <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Anagrafica gamma</h6>

                <div v-if="hasPermission('set id_gamma')" class="flex flex-col pb-3 grow">
                    <Field field_name="ID gamma" type="number"
                           :errors="getErrors('id_gamma')">
                        <div class="relative flex items-center">
                            <input v-model="azienda_model.id_gamma" type="number"
                                   class="p-2 bg-next-gray-md-dark hover:bg-white w-full pr-7">
                            <Spinner v-show="anagrafica_gamma_loading" class="w-5 absolute right-1 "></Spinner>
                        </div>
                    </Field>
                </div>

                <div v-if="anagrafica_gamma?.CG16_CODICE" class="grid grid-cols-2 col-span-2">
                    <span>Ragione sociale: {{ anagrafica_gamma.CG16_RAGSOANAG }}</span>
                    <span>Partita IVA: {{ anagrafica_gamma.CG16_PARTIVA }}</span>
                    <span>Codice fiscale: {{ anagrafica_gamma.CG16_CODFISCALE }}</span>
                    <span>Codice SDI: {{ anagrafica_gamma.CG1M_CODICE }}</span>
                </div>
                <div v-else class="pb-3">
                    <span>Azienda gamma non associata</span>
                </div>
            </div>


            <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Dati aziendali</h6>

                <div class="grid grid-cols-2 gap-4">
                    <div class="flex flex-col pb-3">
                        <Field field_name="Azienda estera"
                               :errors="getErrors('estera')">
                            <Select v-model="azienda_model.estera"></Select>
                        </Field>
                    </div>
                    <div class="flex flex-col pb-3 grow">
                        <Field field_name="Tipo" :errors="getErrors('tipo')">
                            <VueMultiselect v-model="tipo_model" :options="tipo_options"
                                            :multiple="false"
                                            :allowEmpty="false"
                                            :close-on-select="true" :clear-on-select="false"
                                            selectLabel=""
                                            deselectLabel=""
                                            selectedLabel=""
                                            placeholder="Tipo cliente"
                                            class="next-vue-multiselect-single"
                                            track-by="id" label="text">
                                <template v-slot:noResult>Nessun elemento trovato.</template>
                            </VueMultiselect>
                        </Field>
                    </div>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Partita IVA" :required="!aziendaAutocomplete.selection && !azienda_model.estera && !azienda_model.estera && !tipo_model?.id"
                           :errors="getErrors('partita_iva')">
                        <VueMultiselect
                            v-model="aziendaAutocomplete.selection"
                            :options="aziendaAutocomplete.options"
                            :taggable="true"
                            :clear-on-select="false"
                            :preserveSearch="true"
                            @tag="(value:string)=>aziendaAutocomplete.add({id:-1, partita_iva:value})"
                            placeholder="Partita IVA"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="partita_iva"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            @search-change="anagraficheAutocompleteSarch"
                        >
                            <template v-slot:option="{option}">
                                <div class="flex flex-col text-sm">
                                    <template v-if="option.isTag">
                                        <span>Modifica partita IVA: <span
                                            class="font-bold">{{ option.label }}</span></span>
                                    </template>
                                    <template v-else>
                                        <div class="flex items-center justify-between">
                                            <div class="flex flex-col">

                                                <span>Azienda: <span class="font-bold">{{
                                                        option.partita_iva
                                                    }}</span></span>
                                                <span>Ragione sociale: <span
                                                    class="font-bold">{{ option.ragione_sociale }}</span></span>
                                                <span>CF: <span class="font-bold">{{
                                                        option.codice_fiscale
                                                    }}</span></span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Codice fiscale" :required="!azienda_model.estera && !azienda_model.codice_fiscale"
                           v-model="azienda_model.codice_fiscale"
                           :errors="getErrors('codice_fiscale')">
                    </Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Ragione sociale" :required="!azienda_model.ragione_sociale"
                           v-model="azienda_model.ragione_sociale"
                           :errors="getErrors('ragione_sociale')"></Field>
                </div>

                <div class="flex flex-col mb-3 col-span-2">
                    <MapViewer
                        hide_map
                        v-model:placeId="azienda_model.a_place_id"
                        v-model:lat="azienda_model.a_lat"
                        v-model:lng="azienda_model.a_lng"
                        @addressInformationChange="onAziendaAddressInformationChange">

                        <template v-slot:actual="{actual}">
                            <p>Selezione attuale: <b>{{
                                    actual?.formatted_address || '----'
                                }}</b></p>
                        </template>
                    </MapViewer>
                </div>

                <div class="grid grid-cols-8 gap-3 mb-3">
                    <div class="col-span-6 flex flex-col">
                        <Field field_name="Sede legale via"
                               :required="!azienda_model.sede_legale_via"
                               v-model="azienda_model.sede_legale_via"
                               placeholder="Nome via"
                               :errors="getErrors('sede_legale_via')"></Field>
                    </div>
                    <div class="col-span-2 flex flex-col mb-3">
                        <Field field_name="numero"
                               :required="!azienda_model.sede_legale_numero"
                               v-model="azienda_model.sede_legale_numero"
                               :errors="getErrors('sede_legale_numero')" placeholder="00"></Field>
                    </div>
                </div>

                <div class="flex flex-col mb-3">
                    <Field
                        :required="!sl.na_selection"
                        field_name="Sede legale nazione"
                        :errors="getErrors('sede_legale_nazione_id')">
                        <VueMultiselect
                            v-model="sl.na_selection"
                            :options="sl.na_options"
                            placeholder="Nazione"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="codice"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            @search-change="sl.na_search"
                        >
                            <template v-slot:option="{option}">{{ option.codice }} - {{ option.nome }}</template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Sede legale cap"
                           :required="!azienda_model.sede_legale_cap"
                           v-model="azienda_model.sede_legale_cap"
                           :errors="getErrors('sede_legale_cap')" placeholder="CAP"></Field>
                </div>

                <div v-show="sl.isNazioneItalia" class="col flex flex-col mb-3">
                    <Field :errors="getErrors('sede_legale_provincia_id')"
                           :required="!sl.pa_selection"
                           field_name="Sede legale provincia">
                        <VueMultiselect
                            v-model="sl.pa_selection"
                            :options="sl.pa_options"
                            @tag="(value:string)=>sl.pa_add({id:-1, nome:value})"
                            placeholder="Prov."
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="codice"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            @search-change="sl.pa_search"
                        >
                        </VueMultiselect>
                    </Field>
                </div>
                <div v-show="sl.isNazioneItalia" class="flex flex-col mb-3">
                    <Field :errors="getErrors('sede_legale_comune_id')"
                           :required="!sl.ca_selection"
                           field_name="Sede legale comune">
                        <VueMultiselect
                            v-model="sl.ca_selection"
                            :options="sl.ca_options"
                            @tag="(value:string)=>sl.ca_add({id:-1, nome:value})"
                            placeholder="Comune"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="nome"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            @search-change="sl.ca_search"
                        >
                        </VueMultiselect>
                    </Field>
                </div>

                <div v-show="!sl.isNazioneItalia" class="flex flex-col mb-3">
                    <Field field_name="Sede legale regione estera"
                           :required="!azienda_model.sede_legale_regione_estero"
                           v-model="azienda_model.sede_legale_regione_estero"
                           :errors="getErrors('sede_legale_regione_estero')" placeholder="Regione estera"></Field>
                </div>

                <div v-show="!sl.isNazioneItalia" class="flex flex-col mb-3">
                    <Field field_name="Sede legale città estera"
                           :required="!azienda_model.sede_legale_citta_estero"
                           v-model="azienda_model.sede_legale_citta_estero"
                           :errors="getErrors('sede_legale_citta_estero')" placeholder="Città estera"></Field>
                </div>

                <div></div>

                <div class="grid grid-cols-1 lg:grid-cols-5 mb-3 gap-4">
                    <div class="flex flex-col mb-3 lg:col-span-3">
                        <Field field_name="Numero di dipendenti"
                               v-model="azienda_model.numero_dipendenti"
                               type="number"
                               :errors="getErrors('numero_dipendenti')" placeholder="Numero di dipendenti"></Field>
                    </div>
                    <div class="flex flex-col mb-3 lg:col-span-2">
                        <Field field_name="Dipendenti (Anno)"
                               v-model="azienda_model.dipendenti"
                               type="number"
                               :errors="getErrors('dipendenti')" placeholder="Anno"></Field>
                    </div>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Ricavi"
                           v-model="azienda_model.ricavi"
                           type="number"
                           :errors="getErrors('ricavi')" placeholder="Ricavi"></Field>
                </div>
                <div class="flex flex-col mb-3">
                        <div class="font-bold pb-2">Data chiusura bilancio</div>
                        <div class="flex gap-2">
                            <input v-model="azienda_model.data_chiusura_bilancio" type="date"
                                   class="p-2 bg-next-gray-md w-full">
                        </div>

                </div>
            </div>


            <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Denominazione</h6>
                <div class="flex flex-col mb-3">
                    <Field field_name="Denominazione" :required="true" v-model="azienda_model.denominazione"
                           :errors="getErrors('denominazione')"></Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Sito web" :required="true" v-model="azienda_model.sito"
                           :errors="getErrors('sito')"></Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Gruppo di appartenenza" v-model="azienda_model.gruppo_di_appartenenza"
                           :errors="getErrors('gruppo_di_appartenenza')">
                    </Field>
                </div>

                <div class="col-span-3">
                    <MapViewer
                        v-model:placeId="azienda_model.place_id"
                        v-model:lat="azienda_model.lat"
                        v-model:lng="azienda_model.lng"
                        @addressInformationChange="onAddressInformationChange">

                        <template v-slot:actual="{actual}">
                            <p class="whitespace-nowrap">Selezione attuale: <b>{{
                                    actual?.formatted_address || '----'
                                }}</b></p>
                        </template>
                    </MapViewer>
                </div>

                <div class="grid grid-cols-8 gap-3 mb-3">
                    <div class="col-span-6 flex flex-col">
                        <Field field_name="Sede operativa via" v-model="azienda_model.sede_operativa_via"
                               :errors="getErrors('sede_operativa_via')" placeholder="Nome via"></Field>
                    </div>
                    <div class="col-span-2 flex flex-col">
                        <Field field_name="numero" v-model="azienda_model.sede_operativa_numero"
                               :errors="getErrors('sede_operativa_numero')" placeholder="00"></Field>
                    </div>
                </div>

                <div class="flex flex-col mb-3">
                    <Field :required="false" field_name="Sede operativa nazione"
                           :errors="getErrors('sede_operativa_nazione_id')">
                        <VueMultiselect
                            v-model="so.na_selection"
                            :options="so.na_options"
                            placeholder="Nazione"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="codice"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            @search-change="so.na_search"
                        >
                            <template v-slot:option="{option}">{{ option.codice }} - {{ option.nome }}</template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Sede operativa cap" v-model="azienda_model.sede_operativa_cap"
                           :errors="getErrors('sede_operativa_cap')" placeholder="CAP"></Field>
                </div>

                <div v-show="so.isNazioneItalia" class="flex flex-col mb-3">
                    <Field :required="false" field_name="Sede operativa provincia"
                           :errors="getErrors('sede_operativa_provincia_id')">
                        <VueMultiselect
                            v-model="so.pa_selection"
                            :options="so.pa_options"
                            placeholder="Prov."
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="codice"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            @search-change="so.pa_search"
                        >
                        </VueMultiselect>
                    </Field>
                </div>
                <div v-show="so.isNazioneItalia" class="flex flex-col mb-3">
                    <Field :errors="getErrors('sede_operativa_comune_id')" field_name="Sede operativa comune">
                        <VueMultiselect
                            v-model="so.ca_selection"
                            :options="so.ca_options"
                            @tag="(value:string)=>so.ca_add({id:-1, nome:value})"
                            placeholder="Comune"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="nome"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            @search-change="so.ca_search"
                        >
                        </VueMultiselect>
                    </Field>
                </div>

                <div v-show="!so.isNazioneItalia" class="flex flex-col mb-3">
                    <Field field_name="Sede operativa regione estera"
                           v-model="azienda_model.sede_operativa_regione_estero"
                           :errors="getErrors('sede_operativa_regione_estero')" placeholder="Regione estera"></Field>
                </div>

                <div v-show="!so.isNazioneItalia" class="flex flex-col mb-3">
                    <Field field_name="Sede operativa città estera" v-model="azienda_model.sede_operativa_citta_estero"
                           :errors="getErrors('sede_operativa_citta_estero')" placeholder="Città estera"></Field>
                </div>

                <div class="col-start-1 flex flex-col mb-3">
                    <Field field_name="Email" v-model="azienda_model.email" type="email"
                           :errors="getErrors('email')" placeholder="Email"></Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Email pec" v-model="azienda_model.pec" type="email"
                           :errors="getErrors('pec')" placeholder="Email pec"></Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Telefono 1" v-model="azienda_model.telefono_1"
                           :errors="getErrors('telefono_1')" placeholder="Telefono"></Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Telefono 2" v-model="azienda_model.telefono_2"
                           :errors="getErrors('telefono_2')" placeholder="Telefono"></Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Fax" v-model="azienda_model.fax"
                           :errors="getErrors('fax')" placeholder="Fax"></Field>
                </div>
            </div>


            <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Assegnazioni
                    cliente</h6>

                <router-link :to="{name:'StoricoCliente', params:{id:id}}"
                             class="px-3 -translate-y-1/2 -translate-x-3 top-0 right-0 absolute bg-next-light-gray">
                    Storico clienti</router-link>

                <div class="flex flex-col mb-3">
                    <Field field_name="Settore commerciale" :required="true" v-model="settoriSelections"
                           :errors="getErrors('settori')">
                        <VueMultiselect :searchable="true"
                                        trackBy="descrizione"
                                        label="descrizione"
                                        v-model="settoriSelections"
                                        :options="settoriOptions"
                                        :multiple="true" :taggable="false"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        class="next-vue-multiselect"
                                        placeholder="Settore commerciale"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        tagPlaceholder="Aggiungi settore">
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    {{ option.descrizione }}
                                </MultiselectOption>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Lavoro new business" :errors="getErrors('lavoro_new_business')">
                        <VueMultiselect v-model="buAutocomplete.selection" :options="buAutocomplete.options"
                                        :multiple="true"
                                        :disabled="!hasPermission('set lavoro_new_business')"
                                        @search-change="buAutocomplete.search"
                                        :close-on-select="false" :clear-on-select="false"
                                        placeholder="Lavoro new business"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        tagPlaceholder="Lavoro new business"
                                        class="next-vue-multiselect"
                                        track-by="id" label="name">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">{{
                                            option.label || '&nbsp;'
                                        }}</span>
                                    <span>{{ option.nome }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-xs border rounded-sm p-1">{{ option.label }}</span>
                                <span class="ml-2">{{ option.nome }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col pb-3 border-b lg:border-none border-next-gray-md-dark">
                    <Field field_name="Origine lead" :required="false"
                           :errors="getErrors('origine_lead')">
                        <VueMultiselect v-model="origine_lead_model"
                                        :options="origine_lead_options"
                                        :close-on-select="true" :clear-on-select="false"
                                        placeholder="Origine lead"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect-single"
                                        track-by="id" label="text">
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col pb-3">
                    <Field field_name="Responsabile New Business" :errors="getErrors('responsabile_id')">
                        <VueMultiselect @search-change="responsabileAutocomplete.search"
                                        :loading="responsabileAutocomplete.isLoading"
                                        :options="responsabileAutocomplete.options"
                                        v-model="responsabileAutocomplete.selection"
                                        :disabled="!hasPermission('assegnazione_utenti_crm')"
                                        track-by="id" label="name"
                                        placeholder="Responsabile new business"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect-single">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{option}">
                            <span>
                                <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">{{
                                        option.bu_label
                                    }}</span>
                                <span class="mr-2">{{ option.name }}</span>
                            </span>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-xs border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col pb-3 ">
                    <Field field_name="Presentazione" :errors="getErrors('presentazioni')">
                        <VueMultiselect v-model="presentazioneAutocomplete.selection"
                                        :options="presentazioneAutocomplete.options"
                                        :multiple="true"
                                        @search-change="presentazioneAutocomplete.search"
                                        :disabled="!hasPermission('assegnazione_utenti_crm')"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        placeholder="Presentazione"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect"
                                        track-by="id"
                                        label="name">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                        {{ option.bu_label || '&nbsp;' }}</span>
                                    <span>{{ option.name }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-xs border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col pb-3">
                    <Field field_name="Head of Client / Client Director" :errors="getErrors('accounts')">
                        <VueMultiselect v-model="accountAutocomplete.selection"
                                        :options="accountAutocomplete.options"
                                        :multiple="true"
                                        @search-change="accountAutocomplete.search"
                                        :disabled="!hasPermission('assegnazione_utenti_crm')"
                                        :close-on-select="false" :clear-on-select="false"
                                        placeholder="Head of Client / Client Director"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        tagPlaceholder="Aggiungi Head of Client / Client Director"
                                        class="next-vue-multiselect"
                                        track-by="id" label="name">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">{{
                                            option.bu_label || '&nbsp;'
                                        }}</span>
                                    <span>{{ option.name }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-xs border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>


                <!--albo-->
                <div class="col-start-1 flex flex-col pb-3">
                    <Field field_name="Necessità iscrizione albo fornitori" :errors="getErrors('albo_fornitori')">
                        <VueMultiselect v-model="albo_fornitori_model" :options="albo_fornitori_options"
                                        :multiple="false"
                                        :allowEmpty="false"
                                        :close-on-select="true" :clear-on-select="false"
                                        placeholder="Albo fornitori"
                                        class="next-vue-multiselect-single"
                                        track-by="id" label="text">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col pb-3"
                     :class="{'hidden': azienda_model.albo_fornitori!=='Si'}">
                    <Field field_name="Data limite iscrizione albo fornitori"
                           :errors="getErrors('data_albo_fornitori')">
                        <input :disabled="azienda_model.albo_fornitori !== 'Si'"
                               v-model="azienda_model.data_albo_fornitori" type="date"
                               class="flex-grow p-7px bg-next-gray-md-dark group-hover:bg-white">
                    </Field>
                </div>
                <div class="flex flex-col pb-3"
                     :class="{'hidden': azienda_model.albo_fornitori!=='Si'}">
                    <Field field_name="Referente" :errors="getErrors('referente_id')">
                        <VueMultiselect v-model="referenteAutocomplete.selection"
                                        :options="referenteAutocomplete.options"
                                        @search-change="referenteAutocomplete.search"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        placeholder="Referente"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect-single"
                                        track-by="id"
                                        label="full_name">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col pb-3 col-span-3"
                     :class="{'hidden': azienda_model.albo_fornitori!=='Si'}">
                    <Field field_name="Link portale di iscrizione"
                           :errors="getErrors('link_portale')">
                        <input :disabled="azienda_model.albo_fornitori !== 'Si'"
                               v-model="azienda_model.link_portale" type="url"
                               class="p-2 bg-next-gray-md-dark hover:bg-white w-full">
                    </Field>
                </div>

                <div class="flex flex-col pb-3 border-b lg:border-none border-next-gray-md-dark mb-3">
                    <Field field_name="Non interessato" :required="false"
                           :errors="getErrors('non_interessato_ids')">
                        <VueMultiselect v-model="nonInteressato.selection"
                                        :options="nonInteressato.options"
                                        :multiple="true"
                                        :internal-search="true"
                                        :close-on-select="false" :clear-on-select="false"
                                        placeholder="Non interessato"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect"
                                        track-by="id" label="nome">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">{{
                                            option.label || '&nbsp;'
                                        }}</span>
                                    <span>{{ option.nome }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-xs border rounded-sm p-1">{{ option.label }}</span>
                                <span class="ml-2">{{ option.nome }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
            </div>


            <div>
                <div class="flex flex-col pb-3">
                    <div class="pb-2 font-bold text-sm">Note di presentazione</div>
                    <div class="flex flex-grow justify-self-start bg-white">
                        <NextEditor v-model="azienda_model.note_di_presentazione" class="limit_tiny_mce"></NextEditor>
                    </div>
                </div>
                <div class="flex flex-col pt-4">
                    <div class="pb-2 font-bold text-sm">Note</div>
                    <div class="flex justify-self-start bg-white">
                        <NextEditor v-model="azienda_model.note"></NextEditor>
                    </div>
                </div>
            </div>

        </div>
        <div class="flex justify-end pt-3">
            <NextButton variant="primary" @click="save" v-if="!azienda_model?.non_operativa"
                        class="w-48 text-sm sm:block py-2 px-4 ml-3">Salva <i class="spinner"></i>
            </NextButton>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import aziendeManager from "../api/Aziende";
import settoriManager from "../api/Settori";
import userManager from "../api/Users";
import Autocomplete from "@/setup/Autocomplete";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import NextEditor from "@/components/NextEditor.vue";
import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import businessUnitsManager from "../api/BusinessUnits";
import {mapGetters} from 'vuex';
import ModalApprovaRifiuta from "@/components/ModalApprovaRifiuta.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NextButton from "@/components/NextButton.vue";
import clientiManager from "../api/Clienti";
import {ProvinciaComune} from "@/setup/ProvinciaComuneAutocomplete";
import nonInteressatoBusinessUnitsManager from "../api/NonInteressatoBusinessUnits";
import contattiManager from "../api/Contatti";
import anagraficaGamma from "../api/AnagraficaGamma";
import Spinner from "@/components/Spinner.vue";
import Checkbox from "@/components/Checkbox.vue";
import Select from "@/components/Select.vue";
import MapViewer from "@/components/Address/MapViewer.vue";

@Options({
    name: 'DettaglioAzienda',
    components: {
        MapViewer,
        Select,
        Checkbox,
        Spinner,
        NextButton,
        Alert,
        Breadcrumbs,
        NextEditor,
        Topbar,
        Loading,
        MultiselectOption,
        Field,
        ModalApprovaRifiuta
    },
    props: {
        id: String,
    },
    computed: {
        ...mapGetters([
            'isNewBusiness',
            'hasPermission',
            'me',
        ])
    }
})

export default class DettaglioAzienda extends Vue {
    me!: any
    aziendaAutocomplete: any = setup(() => Autocomplete(aziendeManager))
    responsabileAutocomplete: any = setup(() => Autocomplete(userManager))
    referenteAutocomplete: any = setup(() => Autocomplete(contattiManager))
    presentazioneAutocomplete: any = setup(() => Autocomplete(userManager, true))
    accountAutocomplete: any = setup(() => Autocomplete(userManager, true))
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, true, {crm: 1}))
    nonInteressato: any = setup(() => Autocomplete(nonInteressatoBusinessUnitsManager, true, {crm: 1}))

    sl = setup(() => {
        return ProvinciaComune()
    })
    so = setup(() => {
        return ProvinciaComune()
    })

    origine_lead_options = [
        {id: 0, text: 'referral'},
        {id: 1, text: 'contattaci/sito'},
        {id: 2, text: 'fiere/eventi'},
    ]
    origine_lead_model: any = null

    settoriSelections = []
    settoriOptions = []

    id!: number | string
    loading = false
    approvaModalVisible = false
    approvaError = ''
    forceApproved = true
    permission_denied = false
    saving = false
    hasPermission!: (perm: string) => boolean

    anagrafica_gamma: any = {}
    anagrafica_gamma_loading = false

    azienda_model: any = {
        estera: false,
        denominazione: null,
        azienda_id: null,
        id_gamma: null,
        partita_iva: null,
        ragione_sociale: null,
        codice_fiscale: null,
        gruppo_di_appartenenza: null,
        data_anniversario: null,
        sito: null,
        settori: [],
        sede_legale_via: null,
        sede_legale_numero: null,
        sede_legale_cap: null,
        sede_legale_comune_id: null,
        sede_legale_provincia_id: null,
        sede_legale_nazione_id: null,
        sede_legale_regione_estero: null,
        sede_legale_citta_estero: null,
        sede_operativa_via: null,
        sede_operativa_numero: null,
        sede_operativa_cap: null,
        sede_operativa_comune_id: null,
        sede_operativa_provincia_id: null,
        sede_operativa_nazione_id: null,
        sede_operativa_regione_estero: null,
        sede_operativa_citta_estero: null,
        email: null,
        telefono_1: null,
        telefono_2: null,
        fax: null,
        pec: null,

        lat: null,
        lng: null,
        place_id: null,
        a_lat: null,
        a_lng: null,
        a_place_id: null,

        responsabile_id: null,
        accounts: [],
        presentazioni: [],
        note: null,
        note_di_presentazione: null,
        albo_fornitori: 'No',
        data_albo_fornitori: null,
        link_portale: null,
        referente_id: null,
        approvata: null,
        lavori_new_business_ids: [],
        tipo: 0,
        origine_lead: null,
        non_interessato_ids: []
    }

    albo_fornitori_options = [
        {id: 'No', text: 'No'},
        {id: 'Si', text: 'Sì'},
        {id: 'Ns', text: 'Non serve'}
    ]

    albo_fornitori_model: any = null

    tipo_options = [
        {id: 0, text: 'Privato'},
        {id: 1, text: 'Pubblico'},
    ]
    tipo_model: any = null

    id_gamma_search_timeout = 0
    show_error_form = false

    last_save: any | null = null


    onAziendaAddressInformationChange(address:any){
        this.azienda_model.sede_legale_via = address.route
        this.azienda_model.sede_legale_numero = address.street_number
        this.azienda_model.sede_legale_cap = address.postal_code
        this.azienda_model.sede_legale_regione_estero = address.region
        this.azienda_model.sede_legale_citta_estero = address.locality
        this.sl.disableProvinciaWatcher = true
        this.sl.na_search(address.country).then(() => {
            this.sl.na_selection = this.sl.na_options.find((e: any) => e.nome.toLowerCase() == address?.country?.toLowerCase())
            return this.sl.pa_search(address?.province)
        }).then(() => {
            this.sl.pa_selection = this.sl.pa_options.find((e: any) => e.codice.toLowerCase() == address?.province?.toLowerCase())
            return this.sl.ca_search(address?.locality)
        }).then(() => {
            this.sl.ca_selection = this.sl.ca_options.find((e: any) => e.nome.toLowerCase() == address?.locality?.toLowerCase())
        }).finally(() => {
            this.sl.disableProvinciaWatcher = false
        })
    }

    get toApprove() {
        return this.azienda_model.approvata == null && this.hasPermission('approve aziende') && !this.forceApproved;
    }

    approvaAzienda(approva: boolean) {
        clientiManager.approvazione(this.id, approva).then((response) => {
            this.approvaModalVisible = false
            this.forceApproved = true
        }).catch(() => {
            this.approvaError = 'Si è verificato un errore'
        })
    }

    onAddressInformationChange(address: any) {
        this.azienda_model.sede_operativa_via = address.route
        this.azienda_model.sede_operativa_numero = address.street_number
        this.azienda_model.sede_operativa_cap = address.postal_code
        this.azienda_model.sede_operativa_regione_estero = address.region
        this.azienda_model.sede_operativa_citta_estero = address.locality
        this.so.disableProvinciaWatcher = true
        this.so.na_search(address.country).then(() => {
            this.so.na_selection = this.so.na_options.find((e: any) => e.nome.toLowerCase() == address?.country?.toLowerCase())
            return this.so.pa_search(address?.province)
        }).then(() => {
            this.so.pa_selection = this.so.pa_options.find((e: any) => e.codice.toLowerCase() == address?.province?.toLowerCase())
            return this.so.ca_search(address?.locality)
        }).then(() => {
            this.so.ca_selection = this.so.ca_options.find((e: any) => e.nome.toLowerCase() == address?.locality?.toLowerCase())
        }).finally(() => {
            this.so.disableProvinciaWatcher = false
        })
    }

    save() {
        this.saving = true
        this.permission_denied = false
        return clientiManager.clienteUpdate(this.id, this.azienda_model).then((res) => {
            this.errors = {}
            this.show_error_form = false
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
                this.show_error_form = true
            }
            if (res.response.status == 403) {
                this.permission_denied = true
            }
        }).finally(() => {
            this.saving = false
        })
    }

    @Watch('aziendaAutocomplete.selection')
    azienda(new_value: any, old: any) {
        if (new_value && new_value.id < 0) {
            // permetto di modificare solo se sto inserendo un valore non esistente
            this.azienda_model.partita_iva = new_value?.partita_iva
        } else if (!new_value) {
            this.azienda_model.partita_iva = null
        }
    }

    @Watch('settoriSelections', {deep: true})
    settori(new_value: any, old: any) {
        this.azienda_model.settori = new_value.map((e: any) => e.descrizione)
    }

    @Watch('azienda_model.id_gamma', {deep: true})
    id_gamma(new_value: any, old: any) {
        if (this.id_gamma_search_timeout > 0) {
            clearTimeout(this.id_gamma_search_timeout);
            this.id_gamma_search_timeout = 0
        }
        if (new_value) {
            this.anagrafica_gamma_loading = true
            // @ts-ignore
            this.id_gamma_search_timeout = setTimeout(() => {
                anagraficaGamma.clienteGamma(new_value).then((response: any) => {
                    this.anagrafica_gamma = response.data
                }).finally(() => {
                    this.anagrafica_gamma_loading = false
                })
            }, 500)
        } else {
            this.anagrafica_gamma = {}
        }

    }

    @Watch('buAutocomplete.selection', {deep: true})
    lavoriNB(new_value: any, old: any) {
        this.azienda_model.lavori_new_business_ids = new_value.map((e: any) => e.id)
    }

    @Watch('nonInteressato.selection', {deep: true})
    nonInt(new_value: any, old: any) {
        this.azienda_model.non_interessato_ids = new_value.map((e: any) => e.id)
    }

    @Watch('origine_lead_model')
    lead(new_value: any, old: any) {
        this.azienda_model.origine_lead = new_value ? new_value.id : null
    }

    @Watch('albo_fornitori_model')
    alboFornitori(new_value: any, old: any) {
        this.azienda_model.albo_fornitori = new_value.id
    }

    @Watch('tipo_model')
    tipo(new_value: any, old: any) {
        this.azienda_model.tipo = new_value.id
    }

    @Watch('responsabileAutocomplete.selection')
    responsabile(new_value: any, old: any) {
        this.azienda_model.responsabile_id = new_value?.id || new_value
    }

    @Watch('referenteAutocomplete.selection')
    referente(new_value: any, old: any) {
        this.azienda_model.referente_id = new_value?.id || new_value
    }

    @Watch('presentazioneAutocomplete.selection')
    presantazioni(new_value: any, old: any) {
        this.azienda_model.presentazioni = new_value.map((e: any) => e.id)
    }

    @Watch('accountAutocomplete.selection')
    account(new_value: any, old: any) {
        this.azienda_model.accounts = new_value.map((e: any) => e.id)
    }

    @Watch('sl.pa_selection')
    sede_legale_provincia(new_value: any, old: any) {
        this.azienda_model.sede_legale_provincia_id = new_value?.id || new_value
    }

    @Watch('sl.na_selection')
    sede_legale_nazione(new_value: any, old: any) {
        this.azienda_model.sede_legale_nazione_id = new_value?.id || new_value
    }

    @Watch('sl.ca_selection')
    sede_legale_comune(new_value: any, old: any) {
        this.azienda_model.sede_legale_comune_id = new_value?.id || new_value
    }

    @Watch('so.pa_selection')
    sede_operativa_provincia(new_value: any, old: any) {
        this.azienda_model.sede_operativa_provincia_id = new_value?.id || new_value
    }

    @Watch('so.na_selection')
    sede_operativa_nazione(new_value: any, old: any) {
        this.azienda_model.sede_operativa_nazione_id = new_value?.id || new_value
    }

    @Watch('so.ca_selection')
    sede_operativa_comune(new_value: any, old: any) {
        this.azienda_model.sede_operativa_comune_id = new_value?.id || new_value
    }

    @Watch('azienda_model.albo_fornitori')
    albo_fornitori(new_value: any, old: any) {
        new_value !== 'Si' && (this.azienda_model.data_albo_fornitori = null)
    }

    paths = [
        {
            title: 'Home',
            name: 'Dashboard',
        }, {
            title: 'Anagrafica',
            name: 'DettaglioAzienda',
        }
    ]

    errors = {}

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    anagraficheAutocompleteSarch($event: any, timeout = 500) {
        this.aziendaAutocomplete.search($event, timeout).then(() => {
            this.aziendaAutocomplete.options.map((e: any) => {
                e['$isDisabled'] = true
            })
        })
    }

    created(): void {
        const promises: any[] = []
        this.loading = true
        this.referenteAutocomplete.addAjaxParam('cliente', this.id)
        settoriManager.settori().then((response) => {
            this.settoriOptions = response.data
        })
        promises.push(clientiManager.cliente(this.id).then((response) => {
            this.azienda_model = {...this.azienda_model, ...response.data}
            this.albo_fornitori_model = this.albo_fornitori_options.find((o) => {
                return o.id == this.azienda_model.albo_fornitori
            })
            this.tipo_model = this.tipo_options.find((o) => {
                return o.id == this.azienda_model.tipo
            })

            this.origine_lead_model = this.origine_lead_options.find(e => e.id == this.azienda_model.origine_lead) || null
            this.forceApproved = false
        }).then(() => {
            const local_promises = []
            local_promises.push(this.aziendaAutocomplete.retrieve(this.azienda_model.azienda_id))
            if (this.azienda_model.responsabile_id) {
                local_promises.push(this.responsabileAutocomplete.retrieve(this.azienda_model.responsabile_id))
            }
            if (this.azienda_model.referente_id) {
                local_promises.push(this.referenteAutocomplete.retrieve(this.azienda_model.referente_id))
            }
            local_promises.push(this.so.na_retrieve(this.azienda_model.sede_operativa_nazione_id))
            local_promises.push(this.sl.na_retrieve(this.azienda_model.sede_legale_nazione_id))
            local_promises.push(this.so.pa_retrieve(this.azienda_model.sede_operativa_provincia_id))
            local_promises.push(this.sl.pa_retrieve(this.azienda_model.sede_legale_provincia_id))
            return Promise.all(local_promises)
        }).then(() => {
            const local_promises = [];
            local_promises.push(this.sl.ca_retrieve(this.aziendaAutocomplete.selection?.sede_legale_comune_id))
            local_promises.push(this.so.ca_retrieve(this.azienda_model.sede_operativa_comune_id))
            this.azienda_model.sede_legale_via = this.aziendaAutocomplete.selection?.sede_legale_via
            this.azienda_model.sede_legale_numero = this.aziendaAutocomplete.selection?.sede_legale_numero
            this.azienda_model.sede_legale_cap = this.aziendaAutocomplete.selection?.sede_legale_cap
            return Promise.all(local_promises)
        }))

        promises.push(clientiManager.settoriCommericali(this.id).then((response) => {
            this.settoriSelections = response.data
        }))

        promises.push(clientiManager.presentazioniAzienda(this.id).then((response) => {
            this.presentazioneAutocomplete.selection = response.data
            this.presentazioneAutocomplete.options = response.data
        }))
        promises.push(clientiManager.accountsAzienda(this.id).then((response) => {
            this.accountAutocomplete.selection = response.data
            this.accountAutocomplete.options = response.data
        }))

        promises.push(businessUnitsManager.lavoriNewBusiness(this.id).then((response) => {
            this.buAutocomplete.selection = response.data
            this.buAutocomplete.options = response.data
        }))

        promises.push(nonInteressatoBusinessUnitsManager.nonInteressato(this.id).then((response) => {
            this.nonInteressato.selection = response.data
            this.nonInteressato.options = response.data
            // per caricare tutte le opzione
            this.nonInteressato.search('', 0)
        }))

        Promise.all(promises).finally(() => {
            this.loading = false
        })

        this.responsabileAutocomplete.search('', 0)
        this.accountAutocomplete.search('', 0)
        this.presentazioneAutocomplete.search('', 0)
        this.anagraficheAutocompleteSarch('', 0)
        this.buAutocomplete.search('', 0)
        this.referenteAutocomplete.search('', 0)
        this.so.pa_search('', 0)
        this.sl.pa_search('', 0)
        this.so.ca_search('', 0)
        this.sl.ca_search('', 0)
        this.so.na_search('', 0)
        this.sl.na_search('', 0)
    }
}
</script>


<style lang="scss">

</style>
